import type { ID } from '@octopus-do/octopus-project-core'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { useSelector } from 'react-redux'

import { useAuth } from '@/hooks'

type ThreadFeatures = 'resolve' | 'delete' | 'move' | 'edit'

const useOwnerAccess = () => {
  const owner = useSelector(
    migrationProjectSelector.getIsCurrentUserOwnerOfProject
  )

  if (!owner) {
    return []
  }

  return ['resolve', 'delete', 'move']
}

const useMemberAccess = (authorId: ID | null) => {
  const auth = useAuth()

  const canEdit = useSelector(migrationProjectSelector.getProjectAccessCanEdit)

  const canUpdate = canEdit || auth.id === authorId

  if (!auth.authenticated) {
    return []
  }

  return [
    'resolve',
    canUpdate && 'delete',
    canUpdate && 'move',
    auth.id === authorId && 'edit',
  ]
}

export const useThreadAccess = (
  authorId: ID | null,
  feature: ThreadFeatures
) => {
  const ownerAccess = useOwnerAccess()

  const memberAccess = useMemberAccess(authorId)

  return [...ownerAccess, ...memberAccess].includes(feature)
}
